<ul class="menu">
  @for (item of menu(); track i; let i = $index) {
    @if (item.separator) {
      <li class="menu-separator"></li>
    } @else {
      <li igx-menu-item [item]="item" [index]="i" [root]="true"></li>
    }
  }
</ul>
